/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AttributesCreateParams {
    request?: CreateSuggestAttributesApiRequest;
}

export interface AttributesRequest {
    /** @format int32 */
    categoryId?: number;
    locale?: string;
}

export interface CampaignCreateParams {
    request?: ValidateCampaignCodeApiRequest;
}

export interface CategoryRestrictionDetailParams {
    locale?: string;
    /** @format int32 */
    categoryId: number;
}

export interface ChangeItemsShippingRequest {
    /** @format uuid */
    purchaseOrderId?: string;
    /** @deprecated */
    fromCountry?: string;
    toCountry?: string;
}

export interface CharitiesRequest {
    request?: GetCharitiesApiRequest;
}

export interface ClassifyFromImageRequest {
    draftId?: string;
    imageId?: string;
}

export interface ClosestCollectionPointRequest {
    countryCodeIso2?: string;
    shippingProvider?: string;
    streetName?: string;
    zipCode?: string;
    collectionPointId?: string;
    includeParcelBoxes?: boolean;
}

export interface CollectionPointsUnifaunRequest {
    countryCodeIso2?: string;
    shippingProvider?: string;
    streetName?: string;
    town?: string;
    zipCode?: string;
}

export interface CommissionfeeRequest {
    /** @format int32 */
    categoryId?: number;
    itemType?: string;
    /** @format int32 */
    price?: number;
    /** @format int32 */
    charityId?: number;
}

export interface CompleteApplePurchaseCreateParams {
    request?: CompleteAppleItemFeaturePurchaseApiRequest;
}

export interface CompleteGooglePurchaseCreateParams {
    request?: CompleteGoogleItemFeaturePurchaseApiRequest;
}

export interface ConditionListingTypeFromCategoryRequest {
    isCompany?: boolean;
    /** @format int32 */
    categoryId?: number;
}

export interface DefaultRequest {
    htmlEnabled?: boolean;
}

export interface DraftsCreateParams {
    request?: SaveDraftApiRequest;
}

export interface DraftsDeleteParams {
    request?: DeleteDraftsApiRequest;
}

export interface DraftsDetailParams {
    languageCodeIso2?: string;
    countryCodeIso2?: string;
    draftId: string;
}

export interface DraftsRequest {
    /** @format int32 */
    take?: number;
    /** @format int32 */
    skip?: number;
}

export interface EndItemCreateParams {
    request?: EndItemApiRequest;
}

export interface EndItemsCreateParams {
    request?: EndItemsApiRequest;
}

export interface EndNonShopItemCreateParams {
    request?: EndNonShopItemApiRequest;
}

export interface FeaturefeeRequest {
    request?: GetFeatureFeeApiRequest;
}

export interface ForItemChangeCreateParams {
    request?: CreateDraftForItemChangeApiRequest;
}

export interface FromExtendedLifeTransactionCreateParams {
    request?: CreateDraftFromExtendedLifeTransactionApiRequest;
}

export interface FromItemCreateParams {
    request?: CreateDraftFromItemApiRequest;
}

export interface FromParametersCreateParams {
    request?: CreateDraftFromParametersApiRequest;
}

export interface FromResellCreateParams {
    request?: CreateDraftFromResellApiRequest;
}

export interface FromTemplateCreateParams {
    request?: CreateDraftFromTemplateApiRequest;
}

export interface GetPhysicalSpecsForItemsRequest {
    /** @format uuid */
    purchaseOrderId?: string;
}

export interface ImageColorsRequest {
    imageIds?: string[];
}

export interface InitializePurchaseCreateParams {
    request?: InitializeItemFeaturePurchaseApiRequest;
}

export interface ItemDiscountCreateParams {
    request?: UpdateItemDiscountApiRequest;
}

export interface ItemOndisplayCreateParams {
    request?: UpdateOnDisplayApiRequest;
}

export interface ItemsCreateParams {
    request?: PublishDraftApiRequest;
}

export interface ItemsRestartsCreateParams {
    request?: RestartItemsApiRequest;
}

export interface MemberPrefilledPackagingCostCreateParams {
    request?: UpdateMemberPrefilledPackagingCostApiRequest;
}

export interface MemberPrefilledPackagingCostRequest {
    request?: GetMemberPrefilledPackagingCostApiRequest;
}

export interface MemberSelectedShippingProvidersCreateParams {
    request?: UpdateMemberSelectedShippingProvidersApiRequest;
}

export interface MemberSelectedShippingProvidersRequest {
    request?: GetMemberSelectedShippingProvidersApiRequest;
}

export interface MemberpaymentoptionsRequest {
    /** @format int32 */
    categoryId?: number;
    shippingType?: string[];
    itemType?: string;
}

export interface MemberstateRequest {
    request?: GetMemberStateApiRequest;
}

export interface OffsitePaymentDetectionCreateParams {
    request?: OffsitePaymentDetectionApiRequest;
}

export interface OpenCameraCreateParams {
    request?: OpenCameraApiRequest;
}

export interface PredictFromImagesRequest {
    imageIds?: string[];
    languageCodeIso2?: string;
    draftId?: string;
    itemClassification?: string;
}

export interface ResellCreateParams {
    request?: CreateResellDraftFromItemApiRequest;
}

export interface ReservePriceCreateParams {
    request?: SetItemReservePriceApiRequest;
    itemId: string;
}

export interface ShippingProductsForCountryByWeightSpanAndSizeRequest {
    /** @deprecated */
    fromCountryCode?: string;
    /** @format int32 */
    charityId?: number;
    /** @format int32 */
    itemId?: number;
    shortDescription?: string;
    categoryId?: string;
    draftId?: string;
}

export interface ShippingProductsForCountryByWeightSpanRequest {
    fromCountryCode?: string;
    toCountryCode?: string;
    /** @format uuid */
    purchaseOrderId?: string;
}

export interface ShippingProductsForPurchaseOrderByWeightSpanAndSizeRequest {
    /** @format uuid */
    purchaseOrderId?: string;
    enabledProviderIds?: string[];
}

export interface ShippingproviderswithproductsRequest {
    request?: GetAvailableShippingProvidersWithProductsApiRequest;
}

export interface ShopItemSettingsInfoRequest {
    request?: GetShopItemSettingsInfoApiRequest;
}

export interface SplitPurchaseOrderCreateParams {
    request?: SplitPurchaseOrderApiRequest;
}

export interface TemplatesCountRequest {
    request?: GetTemplatesCountApiRequest;
}

export interface TemplatesCreateParams {
    request?: SaveTemplateApiRequest;
}

export interface TemplatesDeleteParams {
    request?: DeleteTemplatesApiRequest;
}

export interface TemplatesDetailParams {
    languageCodeIso2?: string;
    countryCodeIso2?: string;
    templateId: string;
}

export interface TemplatesRequest {
    /** @format int32 */
    take?: number;
    /** @format int32 */
    skip?: number;
}

export interface TitleToCategoryRequest {
    title?: string;
    searchLanguageCodeIso2?: string;
    draftId?: string;
    imageIds?: string[];
}

export interface ResponseError {
    errorCode?: string | null;
    fieldName?: string | null;
    message?: string | null;
}

export interface ResponseError3 {
    request?: WebSaveDraftApiRequest;
}

export interface ResponseError4 {
    request?: WebPublishDraftApiRequest;
}

export interface ResponseError6 {
    languageCodeIso2?: string;
    countryCodeIso2?: string;
    draftId: string;
}

export interface ResponseError7 {
    /** @deprecated */
    fromCountryCode?: string;
    /** @format int32 */
    charityId?: number;
    /** @format int32 */
    itemId?: number;
}

export interface ResponseStatus {
    errorCode?: string | null;
    errors?: ResponseError[] | null;
    message?: string | null;
    stackTrace?: string | null;
}

export interface AttributeValues {
    numberAttributeValues?: NumberAttributeValue[] | null;
    termAttributeValues?: TermAttributeValue[] | null;
}

export interface NumberAttributeValue {
    /** @format int32 */
    id: number;
    name?: string | null;
    values?: number[] | null;
}

export interface TermAttributeValue {
    autoSelect: boolean;
    /** @format int32 */
    id: number;
    name?: string | null;
    values?: string[] | null;
}

export interface AttributeDefinition {
    backingField?: string | null;
    description?: string | null;
    displayName?: string | null;
    facetType?: string | null;
    /** @format int64 */
    id: number;
    /** @deprecated */
    isMultiSelect: boolean;
    /** @deprecated */
    isRequired: boolean;
    /** @format int32 */
    maxNumberOfValues: number;
    /** @format int32 */
    minNumberOfValues: number;
    possibleValues?: PossibleValue[] | null;
    shouldTranslateValues: boolean;
    /** @format int32 */
    sortOrder: number;
    type: InputType;
}

export interface ChangeItemsShippingPurchaseOrderApiDto {
    isMarkedAsPaidByBuyer: boolean;
    isPaid: boolean;
    isPaidWithIntegratedPayment: boolean;
    items?: SoldItemApiDto[] | null;
    paidStatus?: string | null;
}

export interface ClassifyFromDraftImageApiResponse {
    itemClassification?: string | null;
    responseStatus?: ResponseStatus | null;
}

export interface CollectionPoint {
    countryCode?: string | null;
    displayName?: string | null;
    distance?: string | null;
    id?: string | null;
    isParcelBox: boolean;
    streetName?: string | null;
    town?: string | null;
    zipCode?: string | null;
}

export interface ColorValue {
    color?: string | null;
    /** @format float */
    value: number;
}

export interface CreateDraftForItemChangeApiRequest {
    /** @format int32 */
    itemId: number;
}

export interface CreateDraftForItemChangeApiResponse {
    draftId?: string | null;
    draftReason?: string | null;
    /** @format int32 */
    itemId: number;
    responseStatus?: ResponseStatus | null;
}

export interface CreateDraftFromExtendedLifeTransactionApiRequest {
    requestId?: string | null;
    /** @format int32 */
    transactionId: number;
}

export interface CreateDraftFromExtendedLifeTransactionApiResponse {
    draftId?: string | null;
    responseStatus?: ResponseStatus | null;
}

export interface CreateDraftFromItemApiRequest {
    draftReason?: string | null;
    /** @format int32 */
    itemId: number;
    requestId?: string | null;
}

export interface CreateDraftFromItemApiResponse {
    draftId?: string | null;
    responseStatus?: ResponseStatus | null;
}

export interface CreateDraftFromParametersApiRequest {
    /** @format int32 */
    categoryId?: number | null;
    /** @format int32 */
    openingBid?: number | null;
    shortDescription?: string | null;
}

export interface CreateDraftFromParametersApiResponse {
    draftId?: string | null;
    responseStatus?: ResponseStatus | null;
}

export interface CreateDraftFromResellApiRequest {
    /** @format uuid */
    resellItemId: string;
}

export interface CreateDraftFromResellApiResponse {
    couldNotDownloadAllImages: boolean;
    draftId?: string | null;
    responseStatus?: ResponseStatus | null;
}

export interface CreateDraftFromTemplateApiRequest {
    commandId?: string | null;
    locale?: string | null;
    templateId?: string | null;
}

export interface CreateDraftFromTemplateApiResponse {
    draft?: ItemDraftResponse | null;
    responseStatus?: ResponseStatus | null;
}

export interface CreateResellDraftFromItemApiRequest {
    /** @format int32 */
    itemId: number;
    requestId?: string | null;
}

export interface CreateResellDraftFromItemApiResponse {
    draftId?: string | null;
    responseStatus?: ResponseStatus | null;
}

export interface CreateSuggestAttributesApiRequest {
    /** @format int32 */
    categoryId: number;
    extractorType: ExtractorType;
    shortDescription?: string | null;
}

export interface CreateSuggestAttributesApiResponse {
    attributeValues?: AttributeValues | null;
    extractorType: ExtractorType;
    responseStatus?: ResponseStatus | null;
}

export interface DeleteDraftsApiRequest {
    draftIds?: string[] | null;
}

export interface DeleteDraftsApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface DeleteTemplatesApiRequest {
    templateIds?: string[] | null;
}

export interface DeleteTemplatesApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface DraftImageColorsApiResponse {
    colorValues?: ColorValue[] | null;
    responseStatus?: ResponseStatus | null;
}

export interface CampaignInfo {
    bannerDesktopImageUrl?: string | null;
    bannerMobileImageUrl?: string | null;
    bannerTabletImageUrl?: string | null;
    description?: string | null;
    /** @format double */
    discountFactor?: number | null;
    /** @format int32 */
    id: number;
    isCustomLengthFeeFree: boolean;
    isUnsoldFeeFree: boolean;
    /** @format double */
    maxFeeCap?: number | null;
    /** @format double */
    provisionFactor?: number | null;
}

export interface Category {
    /** @format int32 */
    categoryId: number;
    displayName?: string | null;
    name?: string | null;
}

export interface Charity {
    allowZeroDayAuctions: boolean;
    campaignCode?: string | null;
    /** @format int32 */
    campaignCodeId: number;
    /** @format int32 */
    charityId: number;
    description?: string | null;
    /** @format date-time */
    endDate: string;
    forceFreeShipping: boolean;
    forcePaymentOption?: string | null;
    /** @format date-time */
    lastListingEndDate: string;
    logoUrl?: string | null;
    /** @format int32 */
    memberId: number;
    name?: string | null;
    ribbonUrl?: string | null;
    /** @format date-time */
    startDate: string;
    termsHtml?: string | null;
    termsSummary?: string | null;
}

export interface DeliveryInformation {
    canChangeServicePoint: boolean;
    estimatedDeliveryTime?: EstimatedDeliveryTime | null;
    includeProviderNameForServicePoint: boolean;
    insurance?: Insurance | null;
    isTraceable: boolean;
    mailBoxWithServicePointBackup: boolean;
    servicePoint: boolean;
}

export interface DraftImage {
    imageId?: string | null;
    isUploadedBySystem: boolean;
    /** @format int32 */
    rotationDegrees: number;
    /** @format uuid */
    videoId?: string | null;
}

export interface EstimatedDeliveryTime {
    /** @format int32 */
    maxWeekdays?: number | null;
    /** @format int32 */
    minWeekdays: number;
}

export interface Insurance {
    /** @format double */
    amountPerKilogram?: number | null;
    hasReimbursementUpToPackageCost: boolean;
    /** @format double */
    totalAmount?: number | null;
    /** @format double */
    totalAmountUpToItemValue?: number | null;
}

export interface ItemAdditionalDescription {
    /** @format date-time */
    addedOn: string;
    message?: string | null;
}

export interface ItemDraft {
    descriptionLanguageCodeIso2?: string | null;
    additionalDescriptions?: ItemAdditionalDescription[] | null;
    allowZeroDayAuctions: boolean;
    allowedBuyerRegion?: string | null;
    attributeValues?: ItemDraftAttributeValues | null;
    campaignCode?: string | null;
    campaignCodeDescription?: string | null;
    /** @format int32 */
    campaignCodeId?: number | null;
    /** @format int32 */
    categoryId?: number | null;
    charity?: ItemDraftCharity | null;
    /** @format int32 */
    charityId?: number | null;
    /** @format date-time */
    createdDate: string;
    currency?: string | null;
    customEndTime?: string | null;
    displayHighlighted: boolean;
    displayPromoted: boolean;
    draftId?: string | null;
    draftReason?: string | null;
    /** @format int32 */
    durationDays?: number | null;
    /** @format int32 */
    externalId?: number | null;
    /** @format int32 */
    fixedPrice?: number | null;
    fromCountry?: string | null;
    images?: ItemDraftImage[] | null;
    itemCondition?: string | null;
    itemFeaturesNotOfferedToMember: boolean;
    /** @format int32 */
    itemId: number;
    /** @format date-time */
    lastModifiedDate: string;
    longDescription?: string | null;
    /** @format int32 */
    memberId: number;
    metadata?: ItemDraftMetadata | null;
    /** @format int32 */
    openingBid?: number | null;
    publishedHighlighted: boolean;
    publishedPromoted: boolean;
    /** @format int32 */
    quantity?: number | null;
    reference?: string | null;
    resellPartner?: string | null;
    /** @format int32 */
    reservePrice?: number | null;
    restart: boolean;
    selectedShippingSize?: string | null;
    /** @format int32 */
    selectedShippingWeightInGrams?: number | null;
    sellerIpAddress?: string | null;
    shippingOptions?: ShippingOption[] | null;
    shortDescription?: string | null;
    templateId?: string | null;
    templateName?: string | null;
    /** @format int32 */
    vat?: number | null;
    /** @format int32 */
    version: number;
}

export interface ItemDraftAttributeValues {
    numberAttributeValues?: ItemDraftNumberAttributeValue[] | null;
    termAttributeValues?: ItemDraftTermAttributeValue[] | null;
}

export interface ItemDraftCharity {
    anonymous: boolean;
    /** @format int32 */
    charityId: number;
    /** @format int32 */
    percentageToDonate: number;
}

export interface ItemDraftImage {
    draftImage?: DraftImage | null;
    imageUrl?: string | null;
    listingImage?: ListingImage | null;
}

export interface ItemDraftMetadata {
    applicationId?: string | null;
    clientId?: string | null;
}

export interface ItemDraftNumberAttributeValue {
    /** @format int32 */
    id: number;
    userGenerated: boolean;
    values?: number[] | null;
}

export interface ItemDraftResponse {
    descriptionLanguageCodeIso2?: string | null;
    additionalDescriptions?: ItemAdditionalDescription[] | null;
    allowZeroDayAuctions: boolean;
    allowedBuyerRegion?: string | null;
    attributeValues?: ItemDraftAttributeValues | null;
    campaignCode?: string | null;
    campaignCodeDescription?: string | null;
    /** @format int32 */
    campaignCodeId?: number | null;
    /** @format int32 */
    categoryId?: number | null;
    categoryPath?: Category[] | null;
    charity?: ItemDraftCharity | null;
    /** @format int32 */
    charityId?: number | null;
    /** @format date-time */
    createdDate: string;
    currency?: string | null;
    customEndTime?: string | null;
    displayHighlighted: boolean;
    displayPromoted: boolean;
    draftId?: string | null;
    draftReason?: string | null;
    /** @format int32 */
    durationDays?: number | null;
    /** @format int32 */
    externalId?: number | null;
    /** @format int32 */
    fixedPrice?: number | null;
    fromCountry?: string | null;
    images?: ItemDraftImage[] | null;
    itemCondition?: string | null;
    itemFeaturesNotOfferedToMember: boolean;
    /** @format int32 */
    itemId: number;
    /** @format date-time */
    lastModifiedDate: string;
    longDescription?: string | null;
    /** @format int32 */
    memberId: number;
    metadata?: ItemDraftMetadata | null;
    /** @format int32 */
    openingBid?: number | null;
    publishedHighlighted: boolean;
    publishedPromoted: boolean;
    /** @format int32 */
    quantity?: number | null;
    reference?: string | null;
    resellPartner?: string | null;
    /** @format int32 */
    reservePrice?: number | null;
    restart: boolean;
    selectedShippingSize?: string | null;
    /** @format int32 */
    selectedShippingWeightInGrams?: number | null;
    sellerIpAddress?: string | null;
    shippingOptions?: ShippingOption[] | null;
    shortDescription?: string | null;
    templateId?: string | null;
    templateName?: string | null;
    /** @format int32 */
    vat?: number | null;
    /** @format int32 */
    version: number;
}

export interface ItemDraftTermAttributeValue {
    /** @format int32 */
    id: number;
    userGenerated: boolean;
    values?: string[] | null;
}

export interface Link {
    title?: string | null;
    url?: string | null;
}

export interface ListingImage {
    filename?: string | null;
    /** @format int32 */
    imageGroupId: number;
    /** @format int32 */
    imageId: number;
    isUploadedBySystem: boolean;
    /** @format int32 */
    rotationDegrees: number;
}

export interface PackageRequirements {
    displaySize?: string | null;
    /** @format double */
    maxHeight?: number | null;
    /** @format double */
    maxLength?: number | null;
    /** @format double */
    maxLengthPlusCircumference?: number | null;
    /** @format double */
    maxSumOfAllSides?: number | null;
    /** @format double */
    maxSumOfLengthAndHeight?: number | null;
    /** @format double */
    maxVolume?: number | null;
    /** @format double */
    maxWeight?: number | null;
    /** @format double */
    maxWidth?: number | null;
    /** @format double */
    minHeight?: number | null;
    /** @format double */
    minLength?: number | null;
    /** @format double */
    minWeight?: number | null;
    /** @format double */
    minWidth?: number | null;
    restrictions?: string[] | null;
    satisfiesSizeCategories?: string[] | null;
    sizeCategory?: string | null;
}

export interface ProductsPerWeightSpan {
    products?: ShippingProduct[] | null;
    /** @format double */
    weight: number;
}

export interface ProductsPerWeightSpanAndSize {
    autoSelect: boolean;
    productsBySize?: ShippingProductsBySize[] | null;
    /** @format double */
    weight: number;
}

export interface RestartUnpaidItemResult {
    /** @format int32 */
    oldItemId: number;
    /** @format int32 */
    reservedItemId: number;
    validationError?: string | null;
}

export interface ShippingOption {
    /** @format int32 */
    cost?: number | null;
    /** @format int32 */
    productId?: number | null;
    sizeCategory?: string | null;
    type?: string | null;
    /** @format double */
    weight?: number | null;
}

export interface ShippingProduct {
    deliveryInformation?: DeliveryInformation | null;
    fromCountry?: string | null;
    hasFullyIntegratedShipmentBooking: boolean;
    hideOnSyi: boolean;
    /** @format int32 */
    id: number;
    isSelectedInMemberSettings?: boolean | null;
    isShippingFreeBasedOnCharity: boolean;
    /** @format double */
    lowestRelevantMaxWeight?: number | null;
    name?: string | null;
    officialName?: string | null;
    packageRequirements?: PackageRequirements | null;
    preSelected: boolean;
    /** @format double */
    price: number;
    providerId?: string | null;
    toCountry?: string | null;
    /** @format double */
    weight: number;
}

export interface ShippingProductsBySize {
    autoSelect: boolean;
    availableProviders?: string[] | null;
    /** @format double */
    lowestPrice?: number | null;
    measurements?: string | null;
    products?: ShippingProduct[] | null;
    sizeCategory?: string | null;
}

export interface ShippingProvider {
    fromCountry?: string | null;
    id?: string | null;
    isObsolete: boolean;
    products?: ShippingProviderProduct[] | null;
}

export interface ShippingProviderProduct {
    /** @deprecated */
    insured?: string | null;
    isAddressLabelAtAgent: boolean;
    logoImgUrl?: string | null;
    /** @format int32 */
    maxDiscountPercentage?: number | null;
    /** @format int32 */
    maxInsuredAmount?: number | null;
    name?: string | null;
    /** @deprecated */
    reducedPrice?: string | null;
    summaryDisplayName?: string | null;
    traceable: boolean;
    type?: string | null;
    variants?: ShippingProviderProductVariant[] | null;
}

export interface ShippingProviderProductVariant {
    /** @format int32 */
    height: number;
    /** @format int32 */
    id: number;
    isNew: boolean;
    /** @format int32 */
    length: number;
    mailboxWithServicePointBackup: boolean;
    name?: string | null;
    /** @format int32 */
    price: number;
    restrictionTexts?: string[] | null;
    type?: string | null;
    /** @format double */
    weight: number;
    /** @format int32 */
    width: number;
}

export interface TemplateFromDraft {
    descriptionLanguageCodeIso2?: string | null;
    allowedBuyerRegion?: string | null;
    attributeValues?: ItemDraftAttributeValues | null;
    campaignCode?: string | null;
    /** @format int32 */
    campaignCodeId?: number | null;
    /** @format int32 */
    categoryId?: number | null;
    charity?: ItemDraftCharity | null;
    /** @format int32 */
    charityId?: number | null;
    /** @format date-time */
    createdDate: string;
    currency?: string | null;
    customEndTime?: string | null;
    displayHighlighted: boolean;
    displayPromoted: boolean;
    draftReason?: string | null;
    /** @format int32 */
    durationDays?: number | null;
    /** @format int32 */
    externalId?: number | null;
    /** @format int32 */
    fixedPrice?: number | null;
    fromCountry?: string | null;
    imageContainers?: TemplateFromDraftImageContainer[] | null;
    images?: TemplateImage[] | null;
    itemCondition?: string | null;
    /** @format int32 */
    itemId: number;
    /** @format date-time */
    lastModifiedDate: string;
    longDescription?: string | null;
    /** @format int32 */
    memberId: number;
    name?: string | null;
    /** @format int32 */
    openingBid?: number | null;
    /** @format int32 */
    quantity?: number | null;
    reference?: string | null;
    /** @format int32 */
    reservePrice?: number | null;
    restart: boolean;
    selectedShippingSize?: string | null;
    /** @format int32 */
    selectedShippingWeightInGrams?: number | null;
    sellerIpAddress?: string | null;
    shippingOptions?: ShippingOption[] | null;
    shortDescription?: string | null;
    templateId?: string | null;
    /** @format int32 */
    vat?: number | null;
}

export interface TemplateFromDraftImageContainer {
    listingImage?: ListingImage | null;
    templateImage?: TemplateImage | null;
}

export interface TemplateImage {
    /** @format int32 */
    height: number;
    imageId?: string | null;
    imageUrl?: string | null;
    path?: string | null;
    /** @format int32 */
    rotationDegrees: number;
    /** @format int32 */
    width: number;
}

export interface TemplateResponse {
    descriptionLanguageCodeIso2?: string | null;
    allowedBuyerRegion?: string | null;
    attributeValues?: ItemDraftAttributeValues | null;
    campaignCode?: string | null;
    /** @format int32 */
    campaignCodeId?: number | null;
    /** @format int32 */
    categoryId?: number | null;
    categoryPath?: Category[] | null;
    charity?: ItemDraftCharity | null;
    /** @format int32 */
    charityId?: number | null;
    /** @format date-time */
    createdDate: string;
    currency?: string | null;
    customEndTime?: string | null;
    displayHighlighted: boolean;
    displayPromoted: boolean;
    draftReason?: string | null;
    /** @format int32 */
    durationDays?: number | null;
    /** @format int32 */
    externalId?: number | null;
    /** @format int32 */
    fixedPrice?: number | null;
    fromCountry?: string | null;
    images?: TemplateImage[] | null;
    itemCondition?: string | null;
    /** @format int32 */
    itemId: number;
    /** @format date-time */
    lastModifiedDate: string;
    longDescription?: string | null;
    /** @format int32 */
    memberId: number;
    name?: string | null;
    /** @format int32 */
    openingBid?: number | null;
    /** @format int32 */
    quantity?: number | null;
    reference?: string | null;
    /** @format int32 */
    reservePrice?: number | null;
    restart: boolean;
    selectedShippingSize?: string | null;
    /** @format int32 */
    selectedShippingWeightInGrams?: number | null;
    sellerIpAddress?: string | null;
    shippingOptions?: ShippingOption[] | null;
    shortDescription?: string | null;
    templateId?: string | null;
    /** @format int32 */
    vat?: number | null;
}

export interface WarningLabel {
    isDangerAlert: boolean;
    link?: Link | null;
    text?: string | null;
    title?: string | null;
}

export interface EndItemApiRequest {
    /** @format int32 */
    itemId: number;
}

export interface EndItemApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface EndItemError {
    /** @format int32 */
    itemId: number;
    responseStatus?: ResponseStatus | null;
}

export interface EndItemsApiRequest {
    itemIds?: number[] | null;
}

export interface EndItemsApiResponse {
    errors?: EndItemError[] | null;
    responseStatus?: ResponseStatus | null;
    results?: number[] | null;
}

export interface EndNonShopItemApiRequest {
    /** @format int32 */
    itemId: number;
}

export interface EndNonShopItemApiResponse {
    responseStatus?: ResponseStatus | null;
}

export enum ExtractorType {
    Code = 'Code',
    Tradera = 'Tradera',
    Google = 'Google',
}

export interface GetAttributeDefinitionsApiResponse {
    attributeDefinitions?: AttributeDefinition[] | null;
    responseStatus?: ResponseStatus | null;
}

export type GetAvailableShippingProvidersWithProductsApiRequest = object;

export interface GetAvailableShippingProvidersWithProductsApiResponse {
    responseStatus?: ResponseStatus | null;
    shippingProviders?: ShippingProvider[] | null;
}

export interface GetCategoryRestrictionApiResponse {
    allowUsed: boolean;
    /** @format int32 */
    categoryId: number;
    /** @format int32 */
    currentItemCount: number;
    hasMaxItemCount: boolean;
    hasReachedMaxItemCount: boolean;
    /** @format int32 */
    maxItemCount: number;
    responseStatus?: ResponseStatus | null;
    warningLabel?: WarningLabel | null;
}

export interface GetChangeItemsShippingViewModelApiResponse {
    productsPerWeightSpan?: ProductsPerWeightSpan[] | null;
    purchaseOrder?: ChangeItemsShippingPurchaseOrderApiDto | null;
    responseStatus?: ResponseStatus | null;
}

export type GetCharitiesApiRequest = object;

export interface GetCharitiesApiResponse {
    activeCharities?: Charity[] | null;
    responseStatus?: ResponseStatus | null;
}

export interface GetClosestCollectionPointApiResponse {
    collectionPoint?: CollectionPoint | null;
    responseStatus?: ResponseStatus | null;
}

export interface GetCollectionPointsApiResponse {
    collectionPoints?: CollectionPoint[] | null;
    responseStatus?: ResponseStatus | null;
}

export interface GetCommissionFeeApiResponse {
    /** @format double */
    commissionPercentage: number;
    /** @format double */
    feeIncludingVat: number;
    /** @format double */
    maxFeeIncludingVat: number;
    /** @format double */
    minFeeIncludingVat: number;
    responseStatus?: ResponseStatus | null;
}

export interface GetConditionAndListingTypeFromCategoryApiResponse {
    condition?: string | null;
    itemType?: string | null;
    responseStatus?: ResponseStatus | null;
}

export interface GetDefaultDraftApiResponse {
    newItem?: ItemDraftResponse | null;
    newTemplate?: ItemDraftResponse | null;
    responseStatus?: ResponseStatus | null;
}

export interface GetDraftApiResponse {
    draft?: ItemDraftResponse | null;
    responseStatus?: ResponseStatus | null;
}

export interface GetDraftsPageApiResponse {
    items?: ItemDraftResponse[] | null;
    responseStatus?: ResponseStatus | null;
    /** @format int64 */
    totalCount: number;
}

export type GetFeatureFeeApiRequest = object;

export interface GetFeatureFeeApiResponse {
    /** @format double */
    customEndDateFee: number;
    /** @format double */
    highlightFee: number;
    /** @format double */
    promotedFee: number;
    /** @format double */
    reservePriceFee: number;
    responseStatus?: ResponseStatus | null;
}

export interface GetMemberPaymentOptionsApiResponse {
    paymentOptions?: MemberPaymentOption[] | null;
    responseStatus?: ResponseStatus | null;
}

export type GetMemberPrefilledPackagingCostApiRequest = object;

export interface GetMemberPrefilledPackagingCostApiResponse {
    isChangeAllowed: boolean;
    /** @format int32 */
    packagingCost: number;
    responseStatus?: ResponseStatus | null;
}

export type GetMemberSelectedShippingProvidersApiRequest = object;

export interface GetMemberSelectedShippingProvidersApiResponse {
    availableShippingProviders?: ShippingProviderSetting[] | null;
    responseStatus?: ResponseStatus | null;
    selectedShippingProviders?: ShippingProviderSetting[] | null;
}

export type GetMemberStateApiRequest = object;

export interface GetMemberStateApiResponse {
    /** @format int32 */
    memberId: number;
    /** @format int32 */
    memberState: number;
    responseStatus?: ResponseStatus | null;
}

export interface GetPhysicalSpecsForItemsApiResponse {
    physicalSpecs?: ItemPhysicalSpecsDto[] | null;
    responseStatus?: ResponseStatus | null;
}

export interface GetShippingProductsForCountryByWeightSpanAndSizeApiResponse {
    productsPerWeightSpanAndSize?: ProductsPerWeightSpanAndSize[] | null;
    responseStatus?: ResponseStatus | null;
}

export interface GetShippingProductsForCountryByWeightSpanApiResponse {
    productsPerWeightSpan?: ProductsPerWeightSpan[] | null;
    responseStatus?: ResponseStatus | null;
}

export interface GetShippingProductsForPurchaseOrderByWeightSpanAndSizeApiResponse {
    productsPerWeightSpanAndSize?: ProductsPerWeightSpanAndSize[] | null;
    responseStatus?: ResponseStatus | null;
}

export interface GetShippingProductsForShipmentCheckoutByCountryAndWeightSpanApiResponse {
    productsPerWeightSpan?: ProductsPerWeightSpan[] | null;
    responseStatus?: ResponseStatus | null;
}

export type GetShopItemSettingsInfoApiRequest = object;

export interface GetShopItemSettingsInfoApiResponse {
    /** @format int32 */
    itemsOnDisplayCount: number;
    /** @format int32 */
    itemsWithDiscountCount: number;
    /** @format int32 */
    maxAllowedItemsOnDisplay: number;
    /** @format int32 */
    maxAllowedItemsWithDiscount: number;
    responseStatus?: ResponseStatus | null;
}

export interface GetSplitPurchaseOrderStatusApiResponse {
    responseStatus?: ResponseStatus | null;
    status?: string | null;
}

export interface GetTemplateApiResponse {
    responseStatus?: ResponseStatus | null;
    template?: TemplateResponse | null;
}

export interface GetTemplatesApiResponse {
    items?: TemplateResponse[] | null;
    responseStatus?: ResponseStatus | null;
    /** @format int64 */
    totalCount: number;
}

export type GetTemplatesCountApiRequest = object;

export interface GetTemplatesCountApiResponse {
    responseStatus?: ResponseStatus | null;
    /** @format int64 */
    totalCount: number;
}

export type GetTraderaPackageMeasurementsApiRequest = object;

export interface GetTraderaPackageMeasurementsApiResponse {
    responseStatus?: ResponseStatus | null;
    traderaPackageMeasurements?: TraderaPackageMeasurement[] | null;
}

export enum InputType {
    Unknown = 'Unknown',
    Button = 'Button',
    Color = 'Color',
}

export interface CompleteAppleItemFeaturePurchaseApiRequest {
    /** @format uuid */
    itemFeaturePurchaseId: string;
    productId?: string | null;
    receiptData?: string | null;
    transactionId?: string | null;
}

export interface CompleteGoogleItemFeaturePurchaseApiRequest {
    /** @format uuid */
    itemFeaturePurchaseId: string;
    orderId?: string | null;
    productId?: string | null;
    purchaseToken?: string | null;
}

export interface CompleteItemFeaturePurchaseApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface GetItemFeaturePurchaseApiResponse {
    /** @format uuid */
    itemFeaturePurchaseId: string;
    /** @format int32 */
    itemId: number;
    /** @format int32 */
    memberId: number;
    paymentMethod?: string | null;
    responseStatus?: ResponseStatus | null;
    status?: string | null;
}

export interface InitializeItemFeaturePurchaseApiRequest {
    /** @format date-time */
    customEndDate?: string | null;
    /** @format uuid */
    itemFeaturePurchaseId: string;
    /** @format int32 */
    itemId: number;
    /** @format int32 */
    reservePrice?: number | null;
}

export interface InitializeItemFeaturePurchaseApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface ItemPhysicalSpecsDto {
    /** @format int32 */
    itemId: number;
    /** @format int32 */
    shippingWeightInGrams?: number | null;
    sizeCategory?: string | null;
}

export interface MemberPaymentOption {
    description?: string | null;
    displayName?: string | null;
    paymentType?: string | null;
    recommended: boolean;
}

export interface OffsitePaymentDetectionApiRequest {
    longDescription?: string | null;
}

export interface OffsitePaymentDetectionApiResponse {
    isOffsitePaymentDetected: boolean;
    responseStatus?: ResponseStatus | null;
}

export interface OpenCameraApiRequest {
    draftId?: string | null;
}

export interface OpenCameraApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface PossibleValue {
    /** @format int32 */
    sortOrder: number;
    value?: string | null;
    warningLabel?: WarningLabel | null;
}

export interface PredictionCategoryGroup {
    leafCategories?: PredictionCategoryLevel[] | null;
    parentCategories?: PredictionCategoryLevel[] | null;
}

export interface PredictionCategoryLevel {
    /** @format int32 */
    categoryId: number;
    isLeaf: boolean;
    /** @format int32 */
    level: number;
    name?: string | null;
}

export interface PredictionsFromDraftImageApiResponse {
    /** @format double */
    aiProcessingTime: number;
    longDescription?: string | null;
    /** @format int32 */
    numProcessedImages: number;
    responseStatus?: ResponseStatus | null;
    shortDescription?: string | null;
}

export interface PublishDraftApiRequest {
    draft?: ItemDraft | null;
    hasTraderaPayConsent: boolean;
    publishAsItemType?: string | null;
    requestId?: string | null;
    sellerIpAddress?: string | null;
}

export interface PublishDraftApiResponse {
    /** @format int32 */
    itemId: number;
    publishedAsItemType?: string | null;
    responseStatus?: ResponseStatus | null;
}

export interface RestartItemsApiRequest {
    itemIds?: number[] | null;
}

export interface RestartItemsApiResponse {
    responseStatus?: ResponseStatus | null;
    results?: RestartResult[] | null;
}

export interface RestartResult {
    /** @format int32 */
    oldItemId: number;
    /** @format int32 */
    reservedItemId: number;
    responseStatus?: ResponseStatus | null;
}

export interface RestartUnpaidItemsApiRequest {
    itemIds?: number[] | null;
}

export interface RestartUnpaidItemsApiResponse {
    responseStatus?: ResponseStatus | null;
    results?: RestartUnpaidItemResult[] | null;
}

export interface SaveDraftApiRequest {
    draft?: ItemDraft | null;
}

export interface SaveDraftApiResponse {
    draft?: ItemDraft | null;
    draftId?: string | null;
    responseStatus?: ResponseStatus | null;
    /** @format int32 */
    version: number;
}

export interface SaveTemplateApiRequest {
    requestId?: string | null;
    template?: TemplateFromDraft | null;
}

export interface SaveTemplateApiResponse {
    responseStatus?: ResponseStatus | null;
    templateId?: string | null;
}

export interface SetItemReservePriceApiRequest {
    /** @format int32 */
    itemId: number;
    /** @format int32 */
    reservePrice: number;
}

export interface SetItemReservePriceApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface SetItemVisibilityApiRequest {
    displayHighlighted: boolean;
    displayPromoted: boolean;
    /** @format int32 */
    itemId: number;
}

export interface SetItemVisibilityApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface ShippingProviderSetting {
    insurance?: Insurance | null;
    providerId?: string | null;
    providerSettingId?: string | null;
}

export interface SoldItemApiDto {
    /** @format int32 */
    id: number;
    shippingOptions?: SoldItemShippingOption[] | null;
    title?: string | null;
}

export interface SoldItemShippingOption {
    /** @format double */
    price: number;
    shippingType?: string | null;
    /** @format double */
    weight?: number | null;
}

export interface SplitPurchaseOrderApiRequest {
    /** @format uuid */
    newPurchaseOrderId: string;
    /** @format uuid */
    purchaseOrderId: string;
    transactionIds?: number[] | null;
}

export interface SplitPurchaseOrderApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface TitleToCategoryApiResponse {
    autoSelect: boolean;
    categories?: PredictionCategoryGroup[] | null;
    responseStatus?: ResponseStatus | null;
}

export interface TraderaPackageMeasurement {
    displaySize?: string | null;
    size?: string | null;
}

export interface UpdateItemDiscountApiRequest {
    /** @format int32 */
    discountRate: number;
    /** @format int32 */
    itemId: number;
}

export interface UpdateItemDiscountApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface UpdateMemberPrefilledPackagingCostApiRequest {
    /** @format int32 */
    packagingCost: number;
}

export interface UpdateMemberPrefilledPackagingCostApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface UpdateMemberSelectedShippingProvidersApiRequest {
    selectedShippingProviders?: string[] | null;
}

export interface UpdateMemberSelectedShippingProvidersApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface UpdateOnDisplayApiRequest {
    /** @format int32 */
    itemId: number;
    onDisplay: boolean;
}

export interface UpdateOnDisplayApiResponse {
    responseStatus?: ResponseStatus | null;
}

export interface ValidateCampaignCodeApiRequest {
    code?: string | null;
    selectedBrandAttributes?: string[] | null;
    selectedCategories?: number[] | null;
}

export interface ValidateCampaignCodeApiResponse {
    campaign?: CampaignInfo | null;
    message?: string | null;
    responseStatus?: ResponseStatus | null;
}

export interface VipStatusApiResponse {
    /** @format int32 */
    bidCount: number;
    /** @format int32 */
    campaignCodeId?: number | null;
    categoryPath?: number[] | null;
    displayHighlighted: boolean;
    displayPromoted: boolean;
    /** @format date-time */
    endDate: string;
    /** @format int32 */
    fixedPrice?: number | null;
    hasCustomEndDate: boolean;
    images?: string[] | null;
    isActive: boolean;
    isPureBin: boolean;
    isVipReady: boolean;
    /** @format int32 */
    itemCategoryId: number;
    /** @format int32 */
    itemId: number;
    itemShortDescription?: string | null;
    /** @format int32 */
    openingBid?: number | null;
    /** @format int32 */
    reservePrice?: number | null;
    responseStatus?: ResponseStatus | null;
    /** @format date-time */
    startDate: string;
}

export interface WebGetDraftApiResponse {
    draft?: ItemDraftResponse | null;
    /** @format int32 */
    publishedItemId?: number | null;
    responseStatus?: ResponseStatus | null;
}

export interface WebPublishDraftApiRequest {
    draft?: ItemDraft | null;
    hasTraderaPayConsent: boolean;
    publishAsItemType?: string | null;
    requestId?: string | null;
    sellerIpAddress?: string | null;
}

export interface WebPublishDraftApiResponse {
    /** @format int32 */
    itemId: number;
    publishedAsItemType?: string | null;
    responseStatus?: ResponseStatus | null;
}

export interface WebSaveDraftApiRequest {
    draft?: ItemDraft | null;
}

export interface WebSaveDraftApiResponse {
    draft?: ItemDraft | null;
    draftId?: string | null;
    /** @format int32 */
    publishedItemId?: number | null;
    responseStatus?: ResponseStatus | null;
    /** @format int32 */
    version: number;
}

export interface TraderaPackageMeasurementsRequest {
    request?: GetTraderaPackageMeasurementsApiRequest;
}

export interface UnpaidItemsRestartsCreateParams {
    request?: RestartUnpaidItemsApiRequest;
}

export interface VisibilityCreateParams {
    request?: SetItemVisibilityApiRequest;
    itemId: string;
}
